import Endpoints from '../../../common/Endpoints.vue'
import Request from '../../../common/Request.vue'
import { buildEventReportRequest, normalizeEventReportResponse } from './eventReport'

const requestPage = async (state, filters, pagination) => {
    const request = buildEventReportRequest(filters, pagination)
    const response = await Request.do(state, 'POST', Request.getDefaultHeader(state), request, Endpoints.reports.filter)

    if (!response?.data || response?.isAxiosError) {
        throw new Error('Unable to load the events report')
    }

    return normalizeEventReportResponse(response.data)
}

export const getEventReport = async (state, filters = {}, pagination = {}) => {
    return requestPage(state, filters, pagination)
}

export const getAllEventReportRows = async (state, filters = {}, options = {}) => {
    const limit = Number.isInteger(Number(options.limit)) && Number(options.limit) > 0 ? Number(options.limit) : 500
    const firstPage = await requestPage(state, filters, { page: 1, limit })
    const rows = [...firstPage.results]
    const totalPages = Math.max(1, Math.ceil(firstPage.backendTotalCount / limit))

    for (let page = 2; page <= totalPages; page += 1) {
        const result = await requestPage(state, filters, { page, limit })
        rows.push(...result.results)
    }

    return rows
}
